export default {
    employeeManagement: 'บริหารจัดการพนักงาน',
    importEmployeeList: 'นำเข้ารายชื่อพนักงาน',
    employeeList: 'รายชื่อพนักงาน',
    employeeImage: 'รูปภาพพนักงาน',
    employeeAnnualWorkingHour: 'อัพเดทเวลาทำงานรายปี'
}
